import Head from 'next/head';
import React, { useEffect, useRef, useState } from 'react';

export default function Kontakt() {
    const [formScriptLoaded, setFormScriptLoaded] = useState(false);
    const hasFormScriptLoaded = useRef(false);

    useEffect(() => {
        if (!hasFormScriptLoaded.current) {
            const formScript = document.createElement('script');
            formScript.src = "//js-eu1.hsforms.net/forms/embed/v2.js";
            formScript.async = true;
            formScript.charset = 'utf-8';
            formScript.type = 'text/javascript';
            document.body.appendChild(formScript);

            formScript.onload = () => {
                setFormScriptLoaded(true);
                if (window.hbspt) {
                    window.hbspt.forms.create({
                        target: '#hubspotForm',
                        region: "eu1",
                        portalId: "139600821",
                        formId: "932619f5-af14-4338-ba08-b8d677d33668"
                    });
                }
            }

            hasFormScriptLoaded.current = true;
        }
    }, []);

    const schemaMarkup = JSON.stringify(  {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "name": "Kontakt | deinSEOExpert",
        "description": "Kontaktieren Sie mich, um mehr über meine SEO-Dienstleistungen zu erfahren. Nutzen Sie das Kontaktformular oder finden Sie meine Kontaktdaten auf der Kontaktseite. Dein SEO Expert freut sich darauf, von Ihnen zu hören und Ihnen weiterzuhelfen."
    });

    return (
        <div className="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900">
            <Head>
                <title>Kontakt | deinSEOExpert</title>
                <link rel="icon" href="/favicon.ico"/>
                <meta
                    name="description"
                    content="Kontaktieren Sie mich, um mehr über meine SEO-Dienstleistungen zu erfahren. Nutzen Sie das Kontaktformular oder finden Sie meine Kontaktdaten auf der Kontaktseite. Dein SEO Expert freut sich darauf, von Ihnen zu hören und Ihnen weiterzuhelfen."
                />
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schemaMarkup }} />
            </Head>
            <main className="flex flex-col items-center justify-center flex-grow text-center p-6 gap-12">
                <div className="w-full">
                    <h1 className="text-4xl mb-4">Kontaktieren Sie deinSEOExpert für professionellen SEO Service</h1>
                    {formScriptLoaded && <div id="hubspotForm" className="px-20"></div>}
                </div>
            </main>
        </div>
    );
}
